import { useContext } from 'react';
import AuthContext from '../contexes/AuthContext';

const useAuth = () => {
  const context = useContext(AuthContext);
  return context;
};

export default useAuth;
